export default __webpack_public_path__ + "static/analysts_Logician_INTP_career_path-7f9a965e537e22442a42a3a4b4c3d833.svg";